export enum HomePageWidgets {
  Aggregation = 'aggregators',
  Pipeline = 'pipeline',
  SelfaiBi = 'selfaibi',
  QuickPrototypes = 'quickPrototypes',
  InterpretableModels = 'interpretableModels',
  HighPerformanceModels = 'highPerformanceModels',
  LLMAgents = 'llmAgents',
}
